const calculateVolume = (length, radius) => {
  if (length === null || radius === null) return 0;
  return (length * 3.14 * radius * radius) / 4000000;
};

export default calculateVolume;
